// extracted by mini-css-extract-plugin
export default {"modal":"modal--2Rzir","visible":"visible--lz5vX"};